import printerApi from './../../api/printers';
import { showErrorMessage } from '../../dialogs';

export default {
    namespaced: true,
    state: {
        printers: null,
        selectedPrinters: {},
        fetchInProgress: false, // setFetchInProgress prevents duplicate simultaneous printer fetch API calls
    },
    mutations: {
        setSelectedPrinters(state, printerIds) {
            state.selectedPrinters = printerIds;
        },
        setPrinters(state, printers) {
            state.printers = printers;
        },
        setFetchInProgress(state, inProgress) {
            state.fetchInProgress = inProgress;
        },
    },
    getters: {
        getSelectedPrinters(state) {
            return state.selectedPrinters;
        },
        getPrinters(state) {
            return state.printers;
        },
        getFetchInProgress(state) {
            return state.fetchInProgress || false;
        },
        getSelectedPrinterPostParameter:
            (state) =>
            (variableName = 'preferredPrinters') => {
                const arr = [];
                const selected = state.selectedPrinters || {};
                for (const [key, value] of Object.entries(selected)) {
                    if (value && value.id) {
                        arr.push(parseInt(value.id));
                    }
                }
                return arr;
            },
    },
    actions: {
        fetchPrinters({ commit, state }) {
            // Guard against duplicate simultaneous API calls
            if (state.fetchInProgress) {
                return Promise.resolve();
            }

            commit('setFetchInProgress', true);

            return printerApi
                .fetchAll()
                .then((response) => {
                    const printers = response.data.data;

                    commit('setPrinters', printers);

                    const existingPaperKeys = Object.keys(state.selectedPrinters || {});
                    const newTypes = [];
                    const allTypes = [];
                    const printerIds = new Set(printers.map(p => p.id));

                    // Detect new paper types and track all existing types
                    printers.forEach((printer) => {
                        const paperKey = printer.paperkey;
                        allTypes.push(paperKey);
                        if (
                            !existingPaperKeys.includes(paperKey) &&
                            !newTypes.includes(paperKey)
                        ) {
                            newTypes.push(paperKey);
                        }
                    });

                    const newSelectedPrinters = { ...state.selectedPrinters };

                    // Add null as value for new paper type keys
                    newTypes.forEach((type) => {
                        newSelectedPrinters[type] = null;
                    });

                    // Remove paper type keys that don't have any printers anymore
                    // AND validate that selected printers still exist in the database
                    Object.keys(newSelectedPrinters).forEach((typeId) => {
                        if (!allTypes.includes(typeId)) {
                            delete newSelectedPrinters[typeId];
                        } else if (newSelectedPrinters[typeId] && !printerIds.has(newSelectedPrinters[typeId].id)) {
                            // Selected printer no longer exists in database, clear selection
                            newSelectedPrinters[typeId] = null;
                        }
                    });

                    commit('setSelectedPrinters', newSelectedPrinters);
                })
                .catch((error) => {
                    console.error('Failed to fetch printers:', error);
                    showErrorMessage(`Printer list could not be loaded: ${error.message}`);
                })
                .finally(() => {
                    commit('setFetchInProgress', false);
                });
        },
    },
};

